import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["passwordInput", "toggleButton"];

  toggleVisibility(e) {
    e.preventDefault();

    if (this.passwordInputTarget.type === "password") {
      this.passwordInputTarget.type = "text";
      this.toggleButtonTarget.classList.remove(
        "text-gray-600",
        "dark:text-gray-600"
      );
      this.toggleButtonTarget.classList.add(
        "text-primary",
        "dark:text-primary"
      );
    } else {
      this.passwordInputTarget.type = "password";
      this.toggleButtonTarget.classList.remove(
        "text-primary",
        "dark:text-primary"
      );
      this.toggleButtonTarget.classList.add(
        "text-gray-600",
        "dark:text-gray-600"
      );
    }
  }
}
